jQuery(function($) {
    'use strict';

    var App = function() {
        this.ajaxModalSeletor = '#ajax-modal';

        this.$ajaxModal = new bootstrap.Modal(this.ajaxModalSeletor);
        this.$ajaxModalElem = $(this.ajaxModalSeletor);
        this.ajaxurl = '/wp-content/themes/travelshop/pm-ajax-endpoint.php';
    }

    App.prototype.ajax = function(method, url, data, success, error = function() {}) {
        $.ajax({
            url: url,
            method: method,
            data: data,
            success: success,
            error: error
        });
    }

    App.prototype.modalAjaxLoad = function(url, size = 'default', color = false) {
        var modal = $.App.$ajaxModal;
        var modalElem = $.App.$ajaxModalElem;

        var data = {};

        $.App.ajax('get', url, data, function(response) {
            modalElem.find('.modal-content .modal-title').html(response.html.title);
            modalElem.find('.modal-content .modal-body').html(response.html.content);

            if(color) {
                modalElem.find('.modal-header').addClass('bg-'+color);
            } else {
                modalElem.find('.modal-header').attr('class', 'modal-header');
            }
            modalElem.find('.modal-dialog').attr('class', 'modal-dialog modal-dialog-centered modal-'+size);

            modalElem.trigger('theme.modal.loaded');

            modal.show();
        }, function() {
            $.App.modalAjaxReset();
        });
    }

    App.prototype.modalAjaxReset = function() {
        var modalElem = $.App.$ajaxModalElem;

        var url = $.App.ajaxurl+'?action=ajax-modal-default';
        var data = {};

        $.App.ajax('get', url, data, function(response) {
            modalElem.find('.modal-content .modal-title').html('Lade Daten...');
            modalElem.find('.modal-content .modal-body').html(response.html.content);

            modalElem.find('.modal-header').attr('class', 'modal-header');
            modalElem.find('.modal-dialog').attr('class', 'modal-dialog modal-dialog-centered');

            modalElem.trigger('theme.modal.loaded');
        });
    }

    App.prototype.init = function() {
        /**
         * To Top Badge
         */
        $(window).scroll(function() {
            if($(window).scrollTop() > 100) {
                $('.navbar').addClass('navbar-sticky');
            } else {
                $('.navbar').removeClass('navbar-sticky');
            }

            if($(window).scrollTop() > 500) {
                $('.toTopBadge').removeClass('hideBottom');
            } else {
                $('.toTopBadge').addClass('hideBottom');
            }
        });

        $(document).on('click', '.toTopBadge', function() {
            $('html, body').animate({
                scrollTop: 0
            }, 750);
        });

        $(document).on('click', '.nav-item-has-subnav > a', function() {
            if($(window).width() < 1200) {
                var $subnav = $(this).closest('.nav-item-has-subnav');

                $subnav.toggleClass('open');

                return false;
            }
        });

        /**
         * Sticky
         */
        $('.sticky-wrapper .sticky-item').stick_in_parent({
            offset_top: $('.navbar')[0].offsetHeight + 24,
            recalc_every: 1,
        });

        /**
         * Modal
         */
        this.$ajaxModalElem.on('hidden.bs.modal', function(e) {
            $.App.modalAjaxReset();
        });
    }

    $.App = new App;
    $.App.Constructor = App;
});

jQuery(function($) {
    'use strict';

    $.App.init();
});
